export default function replacelass(
  el: HTMLElement | undefined,
  classname: string,
  replacewith: string
) {
  if (el) {
    if (el.classList.contains(classname)) {
      el.classList.replace(classname, replacewith)
    } else if (replacewith) {
      el.classList.add(replacewith)
    }
  }
}
